import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
	render() {
		return (
			<header id="mainHeader" className="main-header">
				<div className="container">

					<div className="align-items-center d-flex">

						 <button className="app-menu-button menu-button">
							<span className="hamburger-icon">
								<span className="icon-middle"></span>
								<span className="icon-before-after"></span>
							</span>
						 </button>

						 <a className="navbar-brand" href="/" rel="home">málið.is</a>

						 <form role="search" method="get" action="/" className="search-form flex-fill">
							<div className="input-group">

								<label for="search" className="screen-reader-text">Leita</label>

								<input type="search" className="form-control" name="search" id="search" placeholder="Leita" value="" autofocus="" />
								<span className="input-group-btn">
									<button className="btn btn-default" type="submit"><em className="fa fa-search" aria-hidden="true"></em></button>
								</span>
							</div>
						</form>

						<a className="sam-logo" href="http://www.arnastofnun.is">
							<img alt="Brand" src="/img/Stofnunarnamagnussonar-logo.png" data-rjs="/img/Stofnunarnamagnussonar-logo@2x.png" />
						</a>

					</div>

				</div>
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js